var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"a-vg-c--logo"}),_c('div',{class:_vm.closeButtonClass,on:{"click":_vm.toggleLeftMenu}},[_c('image-svg',{attrs:{"imageClass":_vm.iconClass,"imageName":_vm.closeImage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }